<template>
    <!-- Read from the API and never invented here. This is the number somebody quotes
         when they ring us about a hotel doing something unexpected, so a portal that
         has lost contact with the API shows nothing rather than the version it was
         built with — which would be an answer about the wrong half of the system.

         Discreet, and on a guest-facing page deliberately so: a guest opening the link
         to their stay should not be greeted by a build number. It is small, muted and
         at the very bottom, where the person who needs it knows to look. -->
    <p v-if="version" class="version">v{{ version }}</p>
</template>

<script lang="ts" setup>
    import { onMounted, ref } from 'vue'

    import { publicApi } from '@/libs/api'

    const version = ref('')

    onMounted(async () => {
        // The public door: /version needs no token, and this portal is often open on a
        // link whose token has already expired — which is exactly when somebody rings
        // and is asked what it says at the bottom.
        const { status, data } = await publicApi<{ version: string }>('/version')

        if (status === 200 && data?.version) {
            version.value = data.version
        }
    })
</script>

<style scoped>
    .version {
        margin: 24px 0 0;
        padding-bottom: 8px;
        text-align: center;
        font-size: 11px;
        opacity: .45;
    }
</style>
